var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _g2, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRangeObj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 196,
    viewBox: "0 0 282 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247 69H35V127H247V69Z",
    fill: "#12BB6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247 35H35V69H247V35Z",
    fill: "#F8003B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68.5H247",
    stroke: "#F8003B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247 127H35V161H247V127Z",
    fill: "#F8003B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 127.5H247",
    stroke: "#F8003B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2 114.371L64.4 97.3L92.4 79.1L125.3 93.8L149.1 48.3L181.585 114.371L205.1 148.4L225.4 84.7L245 114.371",
    stroke: "#12BB6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2 114.371L64.4 97.3L92.4 79.1L125.3 93.8L149.1 48.3L181.585 114.371L205.1 148.4L225.4 84.7L245 114.371",
    stroke: "#12BB6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5 104.5C69.366 104.5 72.5 101.366 72.5 97.5C72.5 93.634 69.366 90.5 65.5 90.5C61.634 90.5 58.5 93.634 58.5 97.5C58.5 101.366 61.634 104.5 65.5 104.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 100.5C129.366 100.5 132.5 97.366 132.5 93.5C132.5 89.634 129.366 86.5 125.5 86.5C121.634 86.5 118.5 89.634 118.5 93.5C118.5 97.366 121.634 100.5 125.5 100.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 120.5C185.366 120.5 188.5 117.366 188.5 113.5C188.5 109.634 185.366 106.5 181.5 106.5C177.634 106.5 174.5 109.634 174.5 113.5C174.5 117.366 177.634 120.5 181.5 120.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 92.5C230.366 92.5 233.5 89.366 233.5 85.5C233.5 81.634 230.366 78.5 226.5 78.5C222.634 78.5 219.5 81.634 219.5 85.5C219.5 89.366 222.634 92.5 226.5 92.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5 87.5C96.366 87.5 99.5 84.366 99.5 80.5C99.5 76.634 96.366 73.5 92.5 73.5C88.634 73.5 85.5 76.634 85.5 80.5C85.5 84.366 88.634 87.5 92.5 87.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_34",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 46,
    width: 204,
    height: 105
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2 114.371L64.4 97.3L92.4 79.1L125.3 93.8L149.1 48.3L181.585 114.371L205.1 148.4L225.4 84.7L245 114.371",
    stroke: "#12BB6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177 41H120V69H177V41Z",
    fill: "#F8003B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_34",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 46,
    width: 204,
    height: 105
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2 114.371L64.4 97.3L92.4 79.1L125.3 93.8L149.1 48.3L181.585 114.371L205.1 148.4L225.4 84.7L245 114.371",
    stroke: "#12BB6A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229 127H179V156H229V127Z",
    fill: "#F8003B"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.5 54.5C152.366 54.5 155.5 51.366 155.5 47.5C155.5 43.634 152.366 40.5 148.5 40.5C144.634 40.5 141.5 43.634 141.5 47.5C141.5 51.366 144.634 54.5 148.5 54.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 154.5C208.366 154.5 211.5 151.366 211.5 147.5C211.5 143.634 208.366 140.5 204.5 140.5C200.634 140.5 197.5 143.634 197.5 147.5C197.5 151.366 200.634 154.5 204.5 154.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35V161H247",
    stroke: "#CDCDD6",
    strokeWidth: 2.72632,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRangeObj);
export default __webpack_public_path__ + "static/media/range_obj.a962b0ab35250d9749b414816575b3d8.svg";
export { ForwardRef as ReactComponent };